export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5027.f8fef0ac.jpg";